













































































































import Vue from 'vue'
import { mapState } from 'vuex'
import { SpiderRepository, copySpiderSettings } from '@/core/api/spiders'
import { HTTP_FORBIDDEN } from '@/core/http-codes'
import SpiderForm from '@/components/spider-form.vue'
import RunDetail from '@/components/spiders/results/run-detail.vue'
import SourceSample from '@/components/source-sample.vue'
import SpiderAnalyzer from '@/components/spider-analyzer.vue'
import SpiderHistory from '@/components/spider-history.vue'
import SpiderSelect from '@/components/spider-select.vue'
import RunTable from '@/components/spiders/results/run-table.vue'

const spiders = new SpiderRepository()

export default Vue.extend({
  components: {
    SpiderForm,
    RunDetail,
    SourceSample,
    SpiderAnalyzer,
    SpiderHistory,
    SpiderSelect,
    RunTable,
  },
  data: () => ({
    tab: 0,
    spider: null as any,
    errors: {},
    lastRun: null,
    runs: [],
    settingsCloneModal: false,
    settingsCloneFilter: {},
  }),
  computed: mapState({
    user: (state: any) => state.auth.user,
  }),
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      spiders
        .get(this.$route.params.id)
        .then(response => {
          this.spider = response.data
        })
        .catch(() => {
          this.$router.push({ name: 'NotFound' })
        })
    },
    async remove() {
      const { dismiss } = await this.$modalConfirmDanger.fire({
        title: 'Удалить парсер?',
      })
      if (dismiss) {
        return
      }

      this.$store
        .dispatch('spiders/DELETE', { id: this.$route.params.id })
        .then(() => {
          this.$router.push({ name: 'SpiderList' })
        })
        .catch(r => {
          this.errors = r.response?.data ?? {}
        })
    },
    save() {
      return this.$store
        .dispatch('spiders/UPDATE', this.spider)
        .then(({ data }) => {
          this.errors = {}
          this.spider = data
          this.$toastSuccess.fire({
            title: 'Парсер сохранен',
          })
        })
        .catch(r => {
          if (r.response?.status === HTTP_FORBIDDEN) {
            this.$toastError.fire({
              title: 'Недостаточно прав для редактирования парсера в состоянии "Только для чтения"',
            })
            return
          }

          this.errors = r.response?.data ?? {}
          this.$toastError.fire({
            title: 'Ошибка сохранения',
          })
        })
    },
    run() {
      if (this.spider == null) return

      spiders
        .run(this.spider.id)
        .then(r => {
          this.lastRun = r.data['id']
          this.$toastSuccess.fire()
          this.tab = 1
        })
        .catch(() => {
          this.$toastError.fire()
        })
    },
    async clone() {
      const { dismiss } = await this.$modalConfirm.fire({
        title: 'Создать копию парсера?',
      })
      if (dismiss) {
        return
      }

      const clone = { ...this.spider, id: null, note: '', additional: true }

      this.$store
        .dispatch('spiders/CREATE', clone)
        .then(() => {
          this.$toastSuccess.fire({
            title: 'Парсер скопирован',
          })
          this.$router.push({ name: 'SpiderList' })
        })
        .catch(r => {
          this.errors = r.response?.data ?? {}
          this.$toastError.fire({
            title: 'Ошибка копирования',
          })
        })
    },
    onSettingsCloneClick() {
      const hostname = this.getSourceHostname()
      const query = hostname
        .split('.')
        .splice(1)
        .join('.')

      this.settingsCloneFilter = {
        clustered: true,
        query,
      }
      this.settingsCloneModal = true
    },
    onSettingsCloneSelect(spider) {
      this.settingsCloneModal = false
      this.save()
        .then(() => {
          copySpiderSettings(spider.id, [this.spider.id]).then(() => {
            this.fetch()
          })
        })
        .catch(() => {
          this.$toastError.fire({ title: 'Произошла ошибка при копировании настроек парсера' })
        })
    },
    onLastRunTabActive() {
      if (this.lastRun != null) {
        return
      }

      spiders.getLastRunId(this.$route.params.id).then(({ data }) => {
        this.lastRun = data.id
      })
    },
    onRunListTabActive() {
      spiders.getRunList(this.$route.params.id).then(({ data }) => {
        this.runs = data
      })
    },
    onRunListItemClick({ id }) {
      this.lastRun = id
      this.tab = 1
    },
    getSourceHostname() {
      const { hostname } = new URL(this.spider.source.url)
      return hostname
    },
    goBack() {
      this.$router.back()
    },
  },
})
